module.exports = __webpack_public_path__ + "static/vnkucharka-website-video-preview-9cbcdbe9a5b57cbfaac3b54aa4b95152.mp4";